import { withInstall } from "../utils/index.mjs";
import _Cell from "./Cell.mjs";
const Cell = withInstall(_Cell);
var stdin_default = Cell;
export {
  Cell,
  stdin_default as default
};
